module.exports = __webpack_public_path__ + "media/berlin/exception-berlin-423928ba.webp";